import React from "react";
import HeaderSmall from "../../components/header/header-small";
import HeaderLarge from "../../components/header/header-large";
import useWindowSize from "../../hooks/use-window-size";
import Services from "../../components/services/services";
import DesignBrilliance from "../../components/design/design";
import Steps from "../../components/steps/steps";
import Testimonials from "../../components/testimonials/testimonials";
import Footer from "../../components/footer/footer-large";
import Form from "../../components/form/form";
import TestimonialsMobile from "../../components/testimonials/testimonials-small";
import FormMobile from "../../components/form/form-small";
import AnimatedSection from "../../components/animated-section/animated-section";

function HomePage() {
  const { width } = useWindowSize();
  const isMobile = width < 1024;
  const isSmall = width < 768;

  return (
    <div>
      {isMobile ? <HeaderSmall /> : <HeaderLarge />}
      <AnimatedSection>
        <Services />
      </AnimatedSection>
      <AnimatedSection>
        <DesignBrilliance />
      </AnimatedSection>
      <AnimatedSection>
        <Steps />
      </AnimatedSection>
      <AnimatedSection>
        {isSmall ? <TestimonialsMobile /> : <Testimonials />}
      </AnimatedSection>
      <AnimatedSection>
        {isSmall ? <FormMobile /> : <Form />}
        <Footer />
      </AnimatedSection>
    </div>
  );
}

export default HomePage;
